import { DataTable } from "@msuite/ui/table";
import type { Enums } from "@msuite/utils/types";
import { useMailboxes } from "@/hooks/use-mailboxes";
import { MailboxesMenu } from "./mailboxes-menu";
import { columns } from "./table-config";

/** Props Interface */
interface OrganizationMailboxesProps {
	purpose: Enums<"mailboxPurpose">;
}

export function OrganizationMailboxes({ purpose }: OrganizationMailboxesProps) {
	/** Query */
	const { mailboxes, isLoading, queryKey, refetch } = useMailboxes(purpose);

	/** Render */
	return (
		<DataTable
			data={mailboxes}
			columns={columns}
			isLoading={isLoading}
			queryKey={queryKey}
			refetch={refetch}
			menu={<MailboxesMenu purpose={purpose} />}
			persistenceKey={`organization-mailboxes-${purpose}-table`}
			initialPinningState={{ start: ["label"] }}
		/>
	);
}
